
import utils from '@/utils/utils';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {PopupCalendar, HeadBar, HotelSearch, CheckInShow} from '@/components';
import {HotelSearchProxy} from "@/http/RequestProxy.class";
import {mapGetters} from 'vuex';

const hotelSearchProxy = new HotelSearchProxy();
export default {
components: {
HeadBar,
Flexbox,
FlexboxItem,
XButton,
PopupCalendar,
HotelSearch,
CheckInShow,
},
data(){
return {
isShowCalendar: false,
isShowHotelSearch: false,
beginDateForArr: [],
endDateForArr: [],
regionName: '',
searchParams: {
region_id: '',
region_name: '',
hotel_id: '',
place_id: '',
date_from: '',
date_to: '',
},
searchDate: {
dateFromYear: '',
dateFromMonth: '',
dateFromDay: '',
dateFromWeek: '',
dateToYear: '',
dateToMonth: '',
dateToDay: '',
dateToWeek: '',
},
};
},
computed: {
...mapGetters(['getRooms', 'getAdults', 'getChildren']),
},
beforeRouteEnter(to, from, next){
setTimeout(function () {
utils.setBodyStyle({height: '100%'});
}, 50);
next();
},
beforeRouteLeave(to, from, next){
utils.setBodyStyle({height: 'auto'});
next();
},
mounted(){
utils.saveLangAndCurrency(this.$route.query);
this.initDate();
},
methods: {
/** 初始化搜索日期 */
initDate(){
const {today, tomorrow} = utils.getAfterTomorrow();
const fullFromDate = `${today[0]}-${utils.zeroPad(today[1])}-${utils.zeroPad(today[2])}`;
const fullToDate = `${tomorrow[0]}-${utils.zeroPad(tomorrow[1])}-${utils.zeroPad(tomorrow[2])}`;
const searchDate = this.searchDate;

searchDate.dateFromYear = fullFromDate;
searchDate.dateFromMonth = today[1];
searchDate.dateFromDay = today[2];
searchDate.dateFromWeek = today[3];

searchDate.dateToYear = fullToDate;
searchDate.dateToMonth = tomorrow[1];
searchDate.dateToDay = tomorrow[2];
searchDate.dateToWeek = tomorrow[3];

this.setFromAndToDate(today, tomorrow);
today.pop();
tomorrow.pop();
this.beginDateForArr = today;
this.endDateForArr = tomorrow;


this.searchParams.hotel_id = window.localStorage.getItem('hotel_id') || '';
this.searchParams.region_id = window.localStorage.getItem('region_id') || '';
this.searchParams.place_id = window.localStorage.getItem('place_id') || '';

const regionName = window.localStorage.getItem('region_name_str') || '';







this.regionName = regionName;
this.searchParams.region_name = regionName;
},

/** 隐藏搜索popup */
onHideSearch(val){
this.isShowHotelSearch = val;
},

/** 获取选择的城市 */
onGetRegion(resp){
this.regionName = resp.name;
this.searchParams.region_id = resp.region_id;
this.searchParams.place_id = resp.place_id;
this.searchParams.hotel_id = resp.hotel_id;
this.searchParams.region_name = resp.name;


if(resp.location){
this.searchParams.location = resp.location;
this.searchParams.sort_by = 4;
}else{
delete this.searchParams.location;
delete this.searchParams.sort_by;
}

if(resp.hotel_id){
this.onSubmitSearch();
}
},

/** 提交搜索 */
onSubmitSearch(){
if(!this.regionName){
this.$vux.toast.show({
text: this.$i18n.t('hotel.Select_your_destination'),
});

return ;
}

this.saveQuery2Local();
if(this.searchParams.hotel_id){
const params = {
hotel_id: this.searchParams.hotel_id,
start_date: this.searchParams.date_from,
end_date: this.searchParams.date_to,
};

this.$router.push({name: 'hotel-detail', params: params});
}else{
this.$router.push({name: 'hotel-list', query: this.searchParams});
}
},

/** 保存搜索的地区和酒店相关信息到本地 */
saveQuery2Local(){
const q = this.searchParams;

if(q.region_id){
window.localStorage.setItem('region_id', q.region_id);
window.localStorage.removeItem('hotel_id');
window.localStorage.removeItem('place_id');
}else if(q.hotel_id) {
window.localStorage.setItem('hotel_id', q.hotel_id);
window.localStorage.removeItem('region_id');
window.localStorage.removeItem('place_id');
}else if(q.place_id){
window.localStorage.setItem('place_id', q.place_id);
window.localStorage.removeItem('region_id');
window.localStorage.removeItem('hotel_id');
}


if(!q.location){
window.localStorage.setItem('region_name_str', q.region_name);
}
},

/** 获取日期 */
onGetDate(resp){
const fromDate = resp.start;
const toDate = resp.end;
const fullFromDate = `${fromDate[0]}-${utils.zeroPad(fromDate[1])}-${utils.zeroPad(fromDate[2])}`;
const fullToDate = `${toDate[0]}-${utils.zeroPad(toDate[1])}-${utils.zeroPad(toDate[2])}`;
let searchDate = this.searchDate;

searchDate.dateFromYear = fullFromDate;
searchDate.dateFromMonth = fromDate[1];
searchDate.dateFromDay = fromDate[2];
searchDate.dateFromWeek = new Date(fullFromDate).getDay();

searchDate.dateToYear = fullToDate;
searchDate.dateToMonth = toDate[1];
searchDate.dateToDay = toDate[2];
searchDate.dateToWeek = new Date(fullToDate).getDay();

this.setFromAndToDate(fromDate, toDate);
},

/** 保存选择的日期 */
setFromAndToDate(today, tomorrow){
const {start, end} = utils.combineDateFromArr(today, tomorrow);

this.searchParams.date_from = start;
this.searchParams.date_to = end;
},

/** 返回球场预订首页 */
onBackToIndex(){
window.location.href = this.$store.state.WAP_HOST;
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-index/hotel-index.vue